import React from "react"
import PropTypes from "prop-types"
import { Modal, FormGroup, ControlLabel, FormControl } from "react-bootstrap"

import { getText } from "../lib/text"
import Button from "../components/Button"

class CreateCityForm extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { name: "" }
  }

  render() {
    const { onClose, onCreate } = this.props

    return (
      <Modal show onHide={() => onClose()}>
        <Modal.Header>
          {getText("Crear ciudad")}
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <ControlLabel>{getText("Nombre en español")}</ControlLabel>
            <FormControl
              onChange={evt => this.setState({ name: evt.target.value })}
              value={this.state.name}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose()}>
            {getText("Cancelar")}
          </Button>
          <Button
            disabled={!this.state.name}
            bsStyle="success"
            onClick={() => this.state.name && onCreate(this.state.name)}
          >
            {getText("Crear")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

CreateCityForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
}

export default CreateCityForm
